<template>
  <div>
    <div class="col-md-12 m-0 p-0">
      <div class="top-wrapper col-md-12 m-0 pt-4 px-4 pb-0">
        <div class="d-flex justify-content-between">
          <div>
            <h3 class="m-0 p-0">
              Opportunities
              <span class="text-primary" style="font-size:13px">(Finance)</span>
            </h3>
            <small class="text-muted">{{ totalRow }} items found.</small>
          </div>
          <div>
            <b-dropdown
              :text="
                startDate || endDate
                  ? `#gt: ${startDate || '-'}, #lt: ${endDate || '-'}`
                  : `Date: ${dateFilter}`
              "
              v-model="dateFilter"
              size="sm"
              variant="outline-primary"
            >
              <b-dropdown-item @click="changeDateFilter('All')"
                >All</b-dropdown-item
              >
              <b-dropdown-item @click="changeDateFilter('Today')"
                >Today</b-dropdown-item
              >
              <b-dropdown-item @click="customDatesModel = true"
                >Custom</b-dropdown-item
              >
            </b-dropdown>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="tabs mb-auto mt-4">
              <p
                class="mr-3 p-0 mb-0 tab-item"
                :class="{
                  'border-bottom border-primary text-primary':
                    leadStatus == 'All',
                }"
                @click="leadStatus = 'All'"
              >
                All
              </p>
              <p
                class="mr-3 p-0 mb-0 tab-item"
                :class="{
                  'border-bottom border-primary text-primary':
                    leadStatus == 'Scorecard Pending',
                }"
                @click="leadStatus = 'Scorecard Pending'"
              >
                Pending
              </p>
              <p
                class="mr-3 p-0 mb-0 tab-item"
                :class="{
                  'border-bottom border-primary text-primary':
                    leadStatus == 'Scorecard Approved',
                }"
                @click="leadStatus = 'Scorecard Approved'"
              >
                Approved
              </p>
              <p
                class="mr-3 p-0 mb-0 tab-item"
                :class="{
                  'border-bottom border-primary text-primary':
                    leadStatus == 'Followed',
                }"
                @click="leadStatus = 'Followed'"
              >
                Pinned
              </p>
              <p
                class="mr-3 p-0 mb-0 tab-item"
                :class="{
                  'border-bottom border-primary text-primary':
                    leadStatus == 'Converted',
                }"
                @click="leadStatus = 'Converted'"
              >
                Converted
              </p>
              <!-- <p
            class="mr-3 p-0 mb-0 tab-item"
            :class="{ activeTab: dateFilter === 'Today' }"
            @click="dateFilter === 'Today' ? dateFilter = 'All' : dateFilter = 'Today'"
          >
            Today
          </p> -->
            </div>
          </div>
          <div class="my-auto pb-2 col-md-6">
            <div class="row col-md-12 m-0 p-0">
              <div class="my-auto col-md-10 m-0 p-0">
                <b-input-group type="text">
                  <b-form-input
                    size="sm"
                    :type="searchType === 'Mobile' ? 'number' : 'text'"
                    v-model="searchClause"
                    :placeholder="'Looking for ' + searchType"
                  ></b-form-input>
                  <template #append>
                    <b-dropdown
                      size="sm"
                      :text="searchType"
                      variant="outline-primary"
                    >
                      <b-dropdown-item @click="searchType = 'Customer Name'"
                        >Customer Name</b-dropdown-item
                      >
                      <b-dropdown-item @click="searchType = 'Application ID'"
                        >Application ID</b-dropdown-item
                      >
                      <b-dropdown-item @click="searchType = 'Mobile'"
                        >Phone Number</b-dropdown-item
                      >
                    </b-dropdown>
                  </template>
                </b-input-group>
              </div>
              <div class="col-md-2 text-right m-0 p-0">
                <b-button-group class="mx-1" size="sm">
                  <vue-json-to-csv
                    :json-data="idfcLoanData"
                    @error="(val) => errors(val)"
                    :csv-title="'loanDetails'"
                  >
                    <b-button
                      v-b-tooltip.hover
                      title="Export to CSV"
                      size="sm"
                      class=""
                      variant="outline-primary"
                    >
                      <i class="fal fa-download"></i>
                    </b-button>
                  </vue-json-to-csv>
                </b-button-group>
                <b-button
                  @click="loadData"
                  v-b-tooltip.hover
                  title="Refresh"
                  size="sm"
                  variant="outline-primary"
                >
                  <i class="fal fa-redo"></i>
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12 p-0 m-0 mt-4 px-4">
          <div class="mb-2">
            <b-button-group size="sm" v-if="showFilters">
              <b-button disabled variant="outline-primary">
                <i class="fal fa-filter"></i>
              </b-button>
              <b-dropdown
                left
                v-b-tooltip.hover
                title="Stage"
                size="sm"
                variant="outline-primary"
                ref="dropdown"
              >
                <b-dropdown-item @click="toggleStageFilter('All')">
                  <i
                    v-if="ifAllFilterSelected()"
                    class="fal fa-check-square"
                  ></i>
                  <i v-if="!ifAllFilterSelected()" class="fal fa-square"></i>
                  All
                </b-dropdown-item>
                <b-dropdown-item @click="toggleStageFilter('Open')">
                  <i
                    v-if="ifSelectedinFilters('Open')"
                    class="fal fa-check-square"
                  ></i>
                  <i
                    v-if="!ifSelectedinFilters('Open')"
                    class="fal fa-square"
                  ></i>
                  Open
                </b-dropdown-item>
                <b-dropdown-item @click="toggleStageFilter('New')">
                  <i
                    v-if="ifSelectedinFilters('New')"
                    class="fal fa-check-square"
                  ></i>
                  <i
                    v-if="!ifSelectedinFilters('New')"
                    class="fal fa-square"
                  ></i>
                  New
                </b-dropdown-item>
                <b-dropdown-item @click="toggleStageFilter('Followup')">
                  <i
                    v-if="ifSelectedinFilters('Followup')"
                    class="fal fa-check-square"
                  ></i>
                  <i
                    v-if="!ifSelectedinFilters('Followup')"
                    class="fal fa-square"
                  ></i>
                  Followup
                </b-dropdown-item>
                <b-dropdown-item @click="toggleStageFilter('Potential')">
                  <i
                    v-if="ifSelectedinFilters('Potential')"
                    class="fal fa-check-square"
                  ></i>
                  <i
                    v-if="!ifSelectedinFilters('Potential')"
                    class="fal fa-square"
                  ></i>
                  Potential
                </b-dropdown-item>
                <b-dropdown-item @click="toggleStageFilter('Closed')">
                  <i
                    v-if="ifSelectedinFilters('Closed')"
                    class="fal fa-check-square"
                  ></i>
                  <i
                    v-if="!ifSelectedinFilters('Closed')"
                    class="fal fa-square"
                  ></i>
                  Closed
                </b-dropdown-item>
              </b-dropdown>
              <b-dropdown
                left
                :text="sourceSelectedFilter"
                v-b-tooltip.hover
                title="Source"
                size="sm"
                variant="outline-primary"
                v-model="sourceSelectedFilter"
              >
                <b-dropdown-item @click="sourceSelectedFilter = 'All'"
                  >All</b-dropdown-item
                >
                <b-dropdown-item @click="sourceSelectedFilter = 'facebook'"
                  >Facebook</b-dropdown-item
                >
                <b-dropdown-item @click="sourceSelectedFilter = 'Google'"
                  >Google</b-dropdown-item
                >
                <b-dropdown-item @click="sourceSelectedFilter = 'ig_bikeloan'"
                  >Instagram</b-dropdown-item
                >
                <b-dropdown-item @click="sourceSelectedFilter = 'Organic'"
                  >Organic</b-dropdown-item
                >
              </b-dropdown>
              <b-dropdown
                left
                :text="`Limit: ${noLimit ? 'All' : limit}`"
                v-b-tooltip.hover
                title="Limit"
                size="sm"
                variant="outline-primary"
              >
                <b-dropdown-item @click="limit = 10">10</b-dropdown-item>
                <b-dropdown-item @click="limit = 20">20</b-dropdown-item>
                <b-dropdown-item @click="limit = 50">50</b-dropdown-item>
                <b-dropdown-item @click="noLimit = true">All</b-dropdown-item>
              </b-dropdown>
              <b-button
                size="sm"
                @click="resetFilters"
                variant="outline-primary"
              >
                Reset Filters
              </b-button>
              <b-button
                size="sm"
                @click="showFilters = false"
                variant="outline-primary"
              >
                <i class="fal fa-times"></i>
              </b-button>
            </b-button-group>
            <b-button
              variant="outline-info"
              size="sm"
              v-else
              @click="showFilters = true"
            >
              Show Filters
            </b-button>
          </div>
          <div v-if="ifSelectedinFilters('Followup')" class="p-0 mt-4 mb-0">
            <div class="tabs my-auto m-0 p-0" v-if="dateFilter != 'Today'">
              <!-- <p class="m-0 p-0 mr-2">Filter Followup :</p> -->
              <p
                class="mr-3 p-0 mb-0 tab-item"
                :class="{ 'border-bottom border-primary text-primary': followUpStatus == 'All' }"
                @click="followUpStatus = 'All'"
              >
                All
              </p>
              <p
                class="mr-3 p-0 mb-0 tab-item"
                :class="{ 'border-bottom border-primary text-primary': followUpStatus == 'Today' }"
                @click="followUpStatus = 'Today'"
              >
                Today
              </p>
              <p
                class="mr-3 p-0 mb-0 tab-item"
                :class="{ 'border-bottom border-primary text-primary': followUpStatus == 'Overdue' }"
                @click="followUpStatus = 'Overdue'"
              >
                Overdue
              </p>
              <p
                class="mr-3 p-0 mb-0 tab-item"
                :class="{ 'border-bottom border-primary text-primary': followUpStatus == 'Scheduled' }"
                @click="followUpStatus = 'Scheduled'"
              >
                Scheduled
              </p>
            </div>
            <div v-else>
              <b-alert show variant="primary" class="caption">
                Filters for follow up are only valid for date selected as "All",
                please select 'All' date filter.
                <b-button
                  @click="changeDateFilter('All')"
                  size="sm"
                  variant="link"
                  class="m-0 p-0"
                  >Change to All</b-button
                >
              </b-alert>
            </div>
            <hr class="m-0 p-0" />
          </div>
          <div class="m-0 p-0 mt-3 mb-2">
            <b-badge
              variant="primary"
              class="mr-2"
              v-for="(data, index) in stageSelectedFilter"
              :key="index"
            >
              {{ data }}
              <i
                class="fal fa-times-circle"
                @click="toggleStageFilter(data)"
              ></i>
            </b-badge>
          </div>
        </div>
      <div class="px-4 col-md-12">
        <b-spinner v-if="isBusy"></b-spinner>
      </div>
      <div class="col-md-12 px-4" v-for="(idfcLoanData, dataName) in groupByDate" :key="dataName">
        <div
          class="col-md-12 m-0 p-2 my-2 my-2 mt-4"
          style=""
        >
          <h5>
            {{ dataName | moment("MMM Do")}}<span style="font-size:12px" class="text-muted my-auto"
              >, {{ idfcLoanData.length }} unique entries.</span
            >
          </h5>
        </div>
        <div class="m-0 p-0 border" v-for="(data, index) in idfcLoanData" :key="index">
          <div header-tag="header" class="p-1" role="tab">
            <div
              v-b-toggle="'acc' + data.mobileNumber"
              class="m-0 p-1"
              style="background:#fafafa"
            >
              <b-row class="m-0 p-0 rows">
                <b-col class="m-0 p-0 p-2 d-flex">
                  <div
                    v-for="(datastatus, index) in data.status"
                    :key="index"
                    v-b-tooltip.hover
                    :title="datastatus"
                  >
                    <b-icon
                      class="my-auto mr-2"
                      font-scale="0.8"
                      :variant="checkVariantStatus(datastatus)"
                      icon="circle-fill"
                    ></b-icon>
                  </div>
                  <p class="m-0 p-0">
                    <strong
                      >{{ data.firstName || "Not Defined" }}
                      {{ data.lastName || "Not Defined" }}</strong
                    >,
                    <span class="text-muted" style="font-size:12px">{{
                      data.mobileNumber
                    }}</span>
                  </p>
                  <div class="d-flex ml-2">
                    <div
                      class="m-0 p-0"
                      v-for="(otstatusi, index) in data.otStatus"
                      :key="index"
                      v-b-tooltip.hover
                      :title="otstatusi"
                    >
                      <b-badge
                        class="my-auto mr-1"
                        font-scale="0.8"
                        :variant="checkVariantotStatus(otstatusi)"
                        icon="circle-fill"
                      >
                        {{ otstatusi }}
                      </b-badge>
                      <span v-if="otstatusi === 'Followup'">
                        <span style="font-size:10px" class="text-muted" v-for="(dataocc, index) in data.occurance" :key="index">
                          on {{dataocc.nextFollowUp | moment('ll')}}
                        </span>
                      </span>
                    </div>
                  </div>
                </b-col>
                <b-col class="text-right right d-flex justify-content-end">
                  <i
                    v-b-tooltip.hover
                    :title="dataSource"
                    v-for="(dataSource, index) in data.source"
                    :key="index"
                    class="text-var3 my-auto mr-4"
                    :class="checkSource(dataSource)"
                  ></i>
                  <span
                    v-if="data.occurance.length > 1"
                    class="text-muted mr-4 my-auto"
                    style="font-size:10px"
                    >(+ {{ data.occurance.length - 1 }} duplicates)</span
                  >
                  <span class="when-opened my-auto">
                    <i class="fal fa-chevron-up"></i>
                  </span>
                  <span class="when-closed my-auto">
                    <i class="fal fa-chevron-down"></i>
                  </span>
                </b-col>
              </b-row>
            </div>
          </div>
          <b-collapse
            :id="'acc' + data.mobileNumber"
            accordion="my-accordion"
            role="tabpanel"
            class="px-4 py-1"
          >
            <div class="mb-4">
            <table class="table table-borderless m-0 text-center" style="font-size:14px;">
              <thead class="">
                <tr class="" style="background:#e8e9ed">
                  <th class="" scope="col">ID</th>
                  <th class="" scope="col">Mobile</th>
                  <th class="" scope="col">Stage</th>
                  <th class="" scope="col">Status</th>
                  <th class="" scope="col">CreatedAt</th>
                  <th>Source</th>
                </tr>
              </thead>
              <tbody class="">
                <tr
                  class="occurance"
                  v-for="(data, index) in data.occurance"
                  :key="index"
                  @click="onRowSelected(data)"
                >
                  <th class="m-0 p-2" scope="row">{{ data.applicationId }}</th>
                  <td class="m-0 p-2">{{ data.mobileNumber }}</td>
                  <td class="m-0 p-2">
                    <b-badge
                      pill
                      :variant="checkVariantotStatus(data.otStatus)"
                      >{{ data.otStatus }}</b-badge
                    >
                  </td>
                  <td class="m-0 p-2">
                    <b-badge pill :variant="checkVariantStatus(data.status)">{{
                      data.status
                    }}</b-badge>
                  </td>
                  <td class="m-0 p-2">{{ data.createdAt | moment("lll") }}</td>
                  <td>
                    <i
                    v-b-tooltip.hover
                    :title="data.source"
                    :key="index"
                    class="text-var3 my-auto mr-4"
                    :class="checkSource(data.source)"
                  ></i>
                  </td>
                </tr>
              </tbody>
            </table>
            </div>
          </b-collapse>
        </div>
      </div>
      <div
        v-if="!isBusy && idfcLoanData.length === 0"
        style="min-height:300px"  
        class="mt-5 text-center"
      >
        <i style="font-size:40px" class="fal fa-boxes-alt mt-4"></i>
        <p class="mt-4">This seems to be empty, try changing filter.</p>
      </div>
    </div>
    <b-pagination
      v-if="!isBusy && idfcLoanData.length > 0 && !noLimit"
      v-model="currentPage"
      :total-rows="totalRow"
      :per-page="limit"
      aria-controls="my-table"
      align="center"
      class="my-4"
    ></b-pagination>
    <b-modal
      v-model="changeStatusModal"
      centered
      title="Change Status"
      hide-footer
    >
      <div>
        <b-form-select v-model="changeToStatus" class="mb-3">
          <b-form-select-option value="New">New</b-form-select-option>
          <b-form-select-option value="Open">Open</b-form-select-option>
          <b-form-select-option value="Potential"
            >Potential</b-form-select-option
          >
          <b-form-select-option value="Closed">Closed</b-form-select-option>
          <b-form-select-option value="Followup">Followup</b-form-select-option>
        </b-form-select>
        <div v-if="changeToStatus == 'Followup'">
          <b-form-datepicker
            id="example-datepicker"
            v-model="nextFollowUpDate"
            class="mb-2"
          ></b-form-datepicker>
          <div class="my-4">
            <b-form-checkbox v-model="showroomVisit" name="check-button" switch>
              visiting showroom?
            </b-form-checkbox>
          </div>
          <b-alert show class="my-4">
            Providing follow up date will help you easily identify leads
            scheduled to follow on exact date.
          </b-alert>
        </div>
        <div v-if="changeToStatus == 'Closed'">
          <div class="mt-2">
            <b-form-checkbox v-model="solved" name="check-button" switch>
              Converted
            </b-form-checkbox>
          </div>
        </div>
        <div class="text-right">
          <b-button variant="primary" @click="changeStatus()">Submit</b-button>
        </div>
      </div>
    </b-modal>
    <b-sidebar
      v-model="quickOverview"
      right
      no-header-close
      no-header
      backdrop
      shadow
      width="40%"
      class="col-md-6 col-12"
    >
      <!-- width="40%" -->
      <b-container class="p-0 m-0">
        <div
          style="background:blue"
          class="m-0 px-2 pt-4"
          v-for="(data, index) in selected"
          :key="index"
        >
          <div class="d-flex justify-content-between">
            <h4 class="p-0 m-0" style="color:white">
            {{ data.firstName }} {{ data.lastName }}
          </h4>
          <b-button
                    variant="primary ml-2"
                    @click="$router.push('/update/application/'+ data.applicationId)"
                    >Update Form</b-button
                  >
          </div>
          <h3 class="" style="color:white">
            # {{ data.applicationId }}
            <i @click="copy(data.applicationId)" class="fal fa-copy"></i>
          </h3>
          <b-badge class="mb-4" :variant="data.solved ? 'success' : 'warning'">
            {{
              data.solved
                ? "Opportunity Converted"
                : "Opportunity Not Converted"
            }}
          </b-badge>
          <!-- <b-form-checkbox v-model="solved" name="check-button" switch>
               Mark to converted
            </b-form-checkbox> -->
          <!-- <b-button size="sm" small variant="outline-warning" class="ml-2" @click="changeStatus(true)">Change Converted Status</b-button> -->
          <div class="tabs my-auto mb-4">
            <p
              class="mr-3 p-0 mb-0 tab-item"
              style="color:white"
              :class="{ activeTab: activeQuickViewTab === 'cxDetail' }"
              @click="activeQuickViewTab = 'cxDetail'"
            >
              Contact Info
            </p>
            <p
              class="mr-3 p-0 mb-0 tab-item"
              style="color:white"
              :class="{ activeTab: activeQuickViewTab === 'loanDetail' }"
              @click="showLoanDetailsTab"
            >
              Loan Info
            </p>
            <p
              class="mr-3 p-0 mb-0 tab-item"
              style="color:white"
              :class="{ activeTab: activeQuickViewTab === 'comments' }"
              @click="activeQuickViewTab = 'comments'"
            >
              Comments
            </p>
          </div>
        </div>
        <div v-if="selected.length > 0">
          <div v-if="activeQuickViewTab === 'cxDetail'" style="font-size:13px">
            <div class="p-2" v-if="selected">
              <div v-for="(data, index) in selected" :key="index">
                <h5># Basic Info</h5>
                <div class="p-2">
                  <table class="w-100">
                    <tr>
                      <td class="m-0 p-0"><strong>Name</strong></td>
                      <td class="text-right">
                        {{ data.firstName }} {{ data.lastName }}
                      </td>
                    </tr>
                    <tr>
                      <td class="m-0 p-0"><strong>Gender</strong></td>
                      <td class="text-right">{{ data.gender }}</td>
                    </tr>
                    <tr>
                      <td class="m-0 p-0"><strong>Email</strong></td>
                      <td class="text-right">{{ data.emailId }}</td>
                    </tr>
                    <tr>
                      <td class="m-0 p-0"><strong>Phone</strong></td>
                      <td class="text-right">{{ data.mobileNumber }}</td>
                    </tr>
                    <tr>
                      <td class="m-0 p-0"><strong>Date of Birth</strong></td>
                      <td class="text-right">{{ data.dateOfBirth }}</td>
                    </tr>
                  </table>
                </div>
                <div v-for="(dataAddress, index) in data.address" :key="index">
                  <h5>#Address</h5>
                  <div class="p-2">
                    <p>
                      {{
                        dataAddress.addressLine1 +
                          ", " +
                          dataAddress.addressLine2 +
                          ", " +
                          dataAddress.pincode
                      }}
                    </p>
                  </div>
                </div>
                <div v-for="(kycData, index) in data.identifier" :key="index">
                  <h5>#KYC Details</h5>
                  <div class="p-2">
                    <p>{{ kycData.type + ", " + kycData.value }}</p>
                  </div>
                </div>
                <div class="text-center">
                  <b-button
                    @click="toggleFollowStatus(true)"
                    v-if="data.followed == false"
                    variant="outline-primary"
                    >Pin
                    <i class="fal fa-plus"></i>
                  </b-button>
                  <b-button
                    @click="toggleFollowStatus(false)"
                    v-else
                    variant="primary"
                    >Unpin
                    <i class="fal fa-minus"></i>
                  </b-button>
                  <b-button
                    variant="primary ml-2"
                    @click="openChangeStatusModal"
                    >Change Status</b-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="my-4 p-4 text-center">
          <i style="font-size:40px" class="fal fa-frown my-4"></i>
          <p>No item have been selected.</p>
        </div>
        <div v-if="activeQuickViewTab === 'loanDetail'" style="font-size:13px">
          <div v-if="loanDetailsClient">
            <div class="p-2">
              <div
                v-for="(data, index) in loanDetailsClient.loanDetails"
                :key="index"
              >
                <h5># Asset Info</h5>
                <div
                  class="p-2"
                  v-for="(datap, index) in data.product"
                  :key="index"
                >
                  <div v-for="(datao, index) in datap.offers" :key="index">
                    <table class="w-100">
                      <tr>
                        <td class="m-0 p-0 ">
                          <strong>Application ID</strong>
                        </td>
                        <td class="text-right">
                          {{ data.applicationNumber }}
                        </td>
                      </tr>
                      <tr>
                        <td class="m-0 p-0 "><strong>Model Name</strong></td>
                        <td class="text-right">
                          {{ datao.productName || "Rejected" }}
                        </td>
                      </tr>
                      <tr>
                        <td class="m-0 p-0 "><strong>Bike ORP</strong></td>
                        <td class="text-right">
                          {{ datao.offerAmount || 0 | currency }}
                        </td>
                      </tr>
                      <tr>
                        <td class="m-0 p-0 "><strong>LTV</strong></td>
                        <td class="text-right">
                          {{
                            Math.floor(
                              (data.ScorecardEligibleAmount /
                                datao.offerAmount) *
                                100
                            ) || 0
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td class="m-0 p-0 ">
                          <strong>Rate of Interest</strong>
                        </td>
                        <td class="text-right">
                          {{ datap.ROI || 0 }}
                        </td>
                      </tr>
                      <tr>
                        <td class="m-0 p-0 ">
                          <strong>Max Loan Amount</strong>
                        </td>
                        <td class="text-right">
                          {{ data.ScorecardEligibleAmount || 0 | currency }}
                        </td>
                      </tr>
                      <tr>
                        <td class="m-0 p-0 "><strong>Downpayment</strong></td>
                        <td class="text-right">
                          {{
                            selected.length > 0
                              ? selected[0].marginmoney
                              : 0 | currency
                          }}
                          <!-- {{datap.EMIAmount || 0 | currency}} -->
                        </td>
                      </tr>
                      <tr>
                        <td class="m-0 p-0 ">
                          <strong>Disbursement Amount</strong>
                        </td>
                        <td class="text-right">
                          {{ datap.disbursementAmount || 0 | currency }}
                        </td>
                      </tr>
                      <tr>
                        <td class="m-0 p-0 "><strong>EMI</strong></td>
                        <td class="text-right">
                          {{ datap.EMIAmount || 0 | currency }}
                        </td>
                      </tr>
                      <tr>
                        <td class="m-0 p-0 "><strong>Tenure</strong></td>
                        <td class="text-right">
                          {{ datap.netTenor || "NA" }}
                        </td>
                      </tr>
                      <tr>
                        <td class="m-0 p-0 "><strong>Status</strong></td>
                        <td class="text-right">
                          {{ data.subStatus }}
                        </td>
                      </tr>
                      <tr>
                        <td class="m-0 p-0 "><strong>Sub Status</strong></td>
                        <td class="text-right">
                          {{ data.status }}
                        </td>
                      </tr>
                      <div></div>
                    </table>

                    <div class="mt-5">
                      <b-alert
                        show
                        :variant="
                          loanDetailsClient.status.error.length > 0
                            ? 'danger'
                            : 'success'
                        "
                      >
                        <div>
                          <p>{{ loanDetailsClient.status.responseMessage }}</p>
                        </div>
                        <p class="m-0 p-0">
                          {{  loanDetailsClient.status.error.length > 0 ? loanDetailsClient.status.error[0].errorDescription: ''}}
                        </p>
                      </b-alert>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="activeQuickViewTab === 'comments'" style="font-size:13px">
          <idfcComment
            :applicationId="
              selected.length > 0 ? selected[0].applicationId : null
            "
          />
        </div>
        <div class="my-4 text-center">
          <b-spinner v-if="loadingEmi"></b-spinner>
        </div>
      </b-container>
    </b-sidebar>
    <b-modal centered hide-footer hide-header v-model="customDatesModel">
      <div class="row">
        <div class="col">
          <p>Greater Than</p>
          <b-form-datepicker required v-model="startDate"></b-form-datepicker>
        </div>
        <div class="col">
          <p>Less Than</p>
          <b-form-datepicker
            :min="startDate"
            :max="today"
            required
            v-model="endDate"
          ></b-form-datepicker>
        </div>
        <div class="text-right mt-4 col-12">
          <b-button
            variant="outline-primary"
            @click="loadData"
            :disabled="!startDate || !endDate"
            >Search</b-button
          >
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import * as _ from "lodash";
import { HTTP2 } from "../../../axios/http-common";
import moment from "moment";
import VueJsonToCsv from "vue-json-to-csv";
import idfcComment from "../../reusuable/idfcComment.vue";
export default {
  data() {
    return {
      showroomVisit: false,
      isBusy: false,
      fields: [
        "selected",
        {
          key: "firstName",
          sortable: true,
        },
        {
          key: "mobileNumber",
        },
        {
          key: "createdAt",
          formatter: (value) => {
            return moment(value).format("lll");
          },
          sortable: true,
        },
        {
          key: "source",
          label: "Source",
          formatter: (value) => {
            return value ? value : "Organic";
          },
        },
        {
          key: "otStatus",
          label: "Stage",
          formatter: (value) => {
            if (value == "New" || !value) {
              return { value: "New", color: "warning" };
            } else if (value == "Open") {
              return { value: value, color: "success" };
            } else if (value == "Followup") {
              return { value: value, color: "info" };
            } else if (value == "Potential") {
              return { value: value, color: "primary" };
            } else if (value == "Closed") {
              return { value: value, color: "danger" };
            } else {
              return { value: value, color: "dark" };
            }
          },
        },
        {
          key: "status",
          label: "LStatus",
          formatter: (value) => {
            if (value == "Scorecard Approved") {
              return { value: value, color: "green" };
            } else if (value.includes("Pending")) {
              return { value: value, color: "orange" };
            } else {
              return { value: value, color: "red" };
            }
          },
        },
        {
          key: "solved",
          label: "CStatus",
          formatter: (value) => {
            return value ? "CVRTD" : "PEND";
          },
        },
        // {
        //   key: "applicationId",
        //   label: "View",
        // },
      ],
      items: [
        {
          isActive: true,
          age: 40,
          first_name: "Dickerson",
          last_name: "Macdonald",
        },
        { isActive: false, age: 21, first_name: "Larsen", last_name: "Shaw" },
        { isActive: false, age: 89, first_name: "Geneva", last_name: "Wilson" },
        { isActive: true, age: 38, first_name: "Jami", last_name: "Carney" },
      ],
      selected: [],
      idfcLoanData: [],
      currentPage: 1,
      totalRow: 10,
      availableFilter: "",
      sourceOptions: "",
      limit: 10,
      offset: 0,
      leadStatus: "All",
      stageSelectedFilter: ["New", "Open"],
      sourceSelectedFilter: "All",
      changeStatusModal: false,
      changeToStatus: "",
      nextFollowUpDate: "",
      followUpStatus: "All",
      quickOverview: false,
      activeQuickViewTab: "cxDetail",
      loadingEmi: false,
      loanDetailsClient: [],
      noLimit: false,
      dateFilter: "All",
      startDate: null,
      endDate: null,
      showFilters: true,
      searchClause: "",
      customDatesModel: false,
      searchType: "Mobile",
      solved: false,
      changeSolvedToggle: false,
    };
  },
  created() {
    this.loadData();
  },
  components: {
    VueJsonToCsv,
    idfcComment,
  },
  computed: {
    today() {
      return moment().format("ll");
    },
    groupByDate() {
      return _(this.idfcLoanData)
        .groupBy((v) => moment(v.createdAt).format('ll'))
        .mapValues((v) => _.map(v))
        .value();
    },
  },
  watch: {
    noLimit() {
      this.loadData();
    },
    limit() {
      this.noLimit = false;
      this.loadData();
    },
    leadStatus() {
      this.loadData();
    },
    currentPage() {
      this.loadData(true);
    },
    stageSelectedFilter() {
      this.loadData();
    },
    sourceSelectedFilter() {
      this.loadData();
    },
    followUpStatus() {
      this.loadData();
    },
    dateFilter() {
      if (this.dateFilter != "Custom") {
        this.loadData();
      }
    },
    searchClause() {
      if (this.searchType === "Mobile") {
        if (this.searchClause.length > 9) {
          this.loadData();
        } else if (this.searchClause.length < 1) {
          this.loadData();
        }
      } else {
        this.loadData();
      }
    },
    searchType() {
      this.loadData();
    },
  },
  methods: {
    // dateFormat (item) {
    //   console.log(item)
    //   return moment(item.createdAt, 'YYYY-MM-DD').format('DD')
    // },
    checkSource(source) {
      if (source == "facebook" || source == "Facebook") {
        return "fab fa-facebook-f";
      } else if (source == "ig_bikeloan") {
        return "fab fa-instagram";
      } else if (source == "Organic") {
        return "fas fa-leaf";
      } else if (source == "whatsapp") {
        return "fab fa-whatsapp";
      } else if (source == "Google") {
        return "fab fa-google";
      } else {
        return "fab fa-sourcetree";
      }
    },
    checkVariantStatus(data) {
      if (data.includes("Pending")) {
        return "warning";
      } else if (data.includes("Reject")) {
        return "danger";
      } else {
        return "success";
      }
    },
    checkVariantotStatus(value) {
      if (value == "New" || !value) {
        return "warning";
      } else if (value == "Open") {
        return "success";
      } else if (value == "Followup") {
        return "info";
      } else if (value == "Potential") {
        return "primary";
      } else if (value == "Closed") {
        return "danger";
      } else {
        return "dark";
      }
    },
    async copy(id) {
      try {
        await navigator.clipboard.writeText(id);
      } catch ($e) {
        alert("Cannot copy, please copy manually!");
      } finally {
        this.$toasted.show("Copied", { type: "success" }).goAway(1000);
      }
    },
    changeDateFilter(filter) {
      this.startDate = null;
      this.endDate = null;
      this.dateFilter = filter;
    },
    async loadData(paginatedCall) {
      this.customDatesModel = false;
      if (!paginatedCall) {
        this.currentPage = 1
      }
      this.offset =
        this.currentPage > 0 ? (this.currentPage - 1) * this.limit : 0;
      this.isBusy = true;
      try {
        var queryString = {
          limit: this.limit,
          offset: Number(this.offset),
        };
        if (this.noLimit) {
          delete queryString.limit;
          delete queryString.offset;
        }
        var query = {};
        if (this.leadStatus === "All") {
          query.otStatus = { $ne: "Closed" };
        }
        if (
          this.leadStatus != "All" &&
          this.leadStatus != "Followed" &&
          this.leadStatus != "Converted"
        ) {
          query.status = this.leadStatus;
        } else if (this.leadStatus === "Followed") {
          query.followed = true;
        } else if (this.leadStatus === "Converted") {
          query.solved = true;
        }
        if (this.sourceSelectedFilter != "All") {
          query.source = { $in: [this.sourceSelectedFilter] };
        }
        if (this.stageSelectedFilter.length > 0) {
          query.otStatus = { $in: this.stageSelectedFilter };
        }
        if (this.dateFilter === "Today") {
          query.createdAt = {
            gte: moment()
              .add(-1, "days")
              .endOf("day"),
            lt: moment()
              .add(1, "days")
              .endOf("day"),
          };
        }
        if (this.startDate || this.endDate) {
          if (this.startDate) {
            query.createdAt = {};
            query.createdAt["gte"] = moment(this.startDate);
          }
          if (this.endDate) {
            if (!this.startDate) {
              query.createdAt = {};
            }
            query.createdAt["lt"] = moment(this.endDate).endOf("day");
          }
        }

        if (this.followUpStatus === "Today") {
          query.nextFollowUp = {
            gte: moment()
              .add(-1, "days")
              .endOf("day"),
            lt: moment()
              .add(1, "days")
              .endOf("day"),
          };
        } else if (this.followUpStatus === "Overdue") {
          query.nextFollowUp = {
            lt: moment()
              .add(-1, "days")
              .endOf("day"),
          };
        } else if (this.followUpStatus === "Scheduled") {
          query.nextFollowUp = {
            gte: moment().endOf("day"),
          };
        }
        if (this.searchClause && this.searchType === "Application ID") {
          // query.firstName = {$regex: this.searchClause,$options : ['i', 'x']};
          query.applicationId = { $regex: this.searchClause, $options: "i" };
        }
        if (this.searchClause && this.searchType === "Customer Name") {
          query.firstName = { $regex: this.searchClause, $options: "i" };
          // query.applicationId = {$regex: this.searchClause,$options : ['i', 'x']}
        }
        if (this.searchClause.length > 9 && this.searchType === "Mobile") {
          console.log("this");
          var mobile = [];
          mobile.push(Number(this.searchClause));
          query.mobileNumber = { $in: mobile };
        }
        var data = await HTTP2.post(
          "/idfc/get/unique/loan",
          {
            query: query,
          },
          {
            params: queryString,
          }
        );
        console.log(data.data);
        this.idfcLoanData = data.data.loanData;
        this.totalRow = data.data.total;
        this.availableFilter = _.uniqBy(data.data.loanData, "status");
        if (!this.selectedSource) {
          this.sourceOptions = _.uniqBy(data.data.loanData, "source");
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.isBusy = false;
      }
    },
    async changeStatus() {
      var payload = {};
      payload = {
        otStatus: this.changeToStatus,
        nextFollowUp: this.nextFollowUpDate ? this.nextFollowUpDate : null,
        solved: this.solved,
      };
      try {
        await HTTP2.post(
          `/finance/update/loan/prod/${this.selected[0].applicationId}`,
          payload
        );
        if (this.changeToStatus == "Followup") {
          await this.$store.dispatch("addActivity", {
            activity_id: this.selected[0].applicationId,
            type: "Followup",
            description: `scheduled ${
              this.showroomVisit ? "a showroom visit" : "a follow up"
            }`,
            comment: `${
              this.showroomVisit
                ? "Showroom Visit scheduled"
                : "Followup Scheduled"
            } for ${moment(this.nextFollowUpDate).format("ll")}`,
            author: {
              id: localStorage.getItem("agent_id"),
              name: localStorage.getItem("username"),
              agentToken: localStorage.getItem("agentT"),
            },
          });
        } else if (this.changeToStatus == "Closed") {
          await this.$store.dispatch("addActivity", {
            activity_id: this.selected[0].applicationId,
            type: "Closed",
            description: "closed this opportunity",
            comment: `Opportunity have been closed.`,
            author: {
              id: localStorage.getItem("agent_id"),
              name: localStorage.getItem("username"),
              agentToken: localStorage.getItem("agentT"),
            },
          });
        } else {
          await this.$store.dispatch("addActivity", {
            activity_id: this.selected[0].applicationId,
            type: "Tagged",
            description: "changed the stage",
            comment: `Stage have been changed to ${this.changeToStatus}.`,
            author: {
              id: localStorage.getItem("agent_id"),
              name: localStorage.getItem("username"),
              agentToken: localStorage.getItem("agentT"),
            },
          });
        }
      } catch (err) {
        console.log("some error occured");
      } finally {
        this.loadData();
        this.changeStatusModal = false;
        this.quickOverview = false;
        this.$toasted.show("Status Changed.", { type: "success" }).goAway(2000);
        this.solved = false;
      }
    },
    async showLoanDetailsTab() {
      this.loadingEmi = true;
      try {
        var data = await HTTP2.get(
          `/finance/check/loan/prod/${this.selected[0].applicationId}`
        );
        this.loanDetailsClient = data.data;
      } catch (err) {
        console.log("some error occured");
      } finally {
        this.activeQuickViewTab = "loanDetail";
        this.loadingEmi = false;
      }
    },
    async toggleFollowStatus(status) {
      try {
        await HTTP2.post(
          `/finance/update/loan/prod/${this.selected[0].applicationId}`,
          {
            followed: status,
          }
        );
      } catch (err) {
        console.log("some error occured");
      } finally {
        this.$toasted
          .show(status ? "Pinned." : "Removed from Pin", { type: "success" })
          .goAway(1000);
        this.quickOverview = false;
        this.loadData();
      }
    },
    resetFilters() {
      this.leadStatus = "All";
      this.sourceSelectedFilter = "All";
      this.stageSelectedFilter = ["New", "Open"];
      this.limit = 10;
      this.noLimit = false;
      this.$toasted
        .show("All Filter Reset Done", { type: "success" })
        .goAway(1000);
    },
    ifSelectedinFilters(stage) {
      return this.stageSelectedFilter.includes(stage);
    },
    ifAllFilterSelected() {
      const list = ["New", "Open", "Followup", "Potential", "Closed"];
      return list.every((value) => {
        return this.stageSelectedFilter.includes(value);
      });
    },
    toggleStageFilter(stage) {
      if (stage == "All") {
        if (this.ifAllFilterSelected()) {
          this.stageSelectedFilter = ["New", "Open"];
        } else {
          this.stageSelectedFilter = [
            "New",
            "Open",
            "Followup",
            "Potential",
            "Closed",
          ];
        }
      } else {
        if (this.ifSelectedinFilters(stage)) {
          console.log(this.stageSelectedFilter.length);
          if (this.stageSelectedFilter.length <= 1) {
            this.$bvToast.toast(`Please select atleast one stage.`, {
              title: "Bad Request",
              autoHideDelay: 3000,
              appendToast: false,
              variant: "danger",
              solid: true,
              toaster: "b-toaster-bottom-center",
            });
          } else {
            this.stageSelectedFilter.splice(
              this.stageSelectedFilter.indexOf(stage),
              1
            );
            console.log("bigger");
          }
        } else {
          this.stageSelectedFilter.push(stage);
        }
      }
    },
    openChangeStatusModal() {
      this.changeToStatus = this.selected[0].otStatus;
      this.changeStatusModal = true;
    },
    openQuickViewModal(data) {
      this.activeQuickViewTab = "cxDetail";
      // this.changeSolvedToggle = this.selected[0].solved
      this.quickOverview = true;
      this.onRowSelected(data);
    },
    onRowSelected(items) {
      this.selected = [];
      this.selected.push(items);
      console.log(this.selected);
      this.activeQuickViewTab = "cxDetail";
      this.quickOverview = true;
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected();
    },
    selectParticularRow(indexSelected) {
      this.$refs.selectableTable.selectRow(indexSelected);
    },
    unselectThirdRow() {
      // Rows are indexed from 0, so the third row is index 2
      this.$refs.selectableTable.unselectRow(2);
    },
  },
};
</script>

<style>
.wrapper {
  background: white !important;
}
.activeTab {
  border-bottom: 5px solid #0c6efd;
}
.tabs {
  cursor: pointer;
  display: flex;
  color: gray;
}
.tabs .activeTab {
  color: #0c6efd;
}
.tab-item:hover {
  color: rgb(10, 10, 156);
}
.occurance {
  cursor: pointer;
}
.occurance:hover {
  background: #f3f4f7
}
.floatingSheet {
  background: white;
  min-width: 220px;
  position: absolute;
  top: 150px;
}
.collapsed > .rows > .right > .when-opened,
:not(.collapsed) > .rows > .right > .when-closed {
  display: none !important;
}
.top-wrapper {
  background: #f3f4f7;
}
</style>
